export const TO = 'to';
export const FROM = 'from';
export const CC = 'cc';
export const BCC = 'bcc';
export const DATE = 'date';
export const SUBJECT = 'subject';
export const ORIGINAL_SENDER = 'originalSender';